'use client'

import { clearTelemetryContext, setTelemetryContext, toNumericIdList } from '@/lib/telemetry/safe-telemetry'
import { Session } from '@/types/core-types'
import React, { useEffect } from 'react'

type AuthStatus = 'authenticated' | 'unauthenticated' | 'loading' | 'anonymous'
type AuthContext = Partial<{
  session?: Session
  token?: string
  status: AuthStatus
}>
export const AuthContext = React.createContext<AuthContext>({
  status: 'loading',
})

type AuthProviderProps = {
  session?: Session
  token?: string
} & React.PropsWithChildren<{}>
export default function AuthProvider(props: AuthProviderProps) {
  const status = props?.session?.role ?? 0 > 1 ? 'authenticated' : props?.session?.isAnonymous ? 'anonymous' : 'loading'
  const session = props.session
  const token = props.token

  // Propagate session context into telemetry for all tracked events
  useEffect(() => {
    if (session?.isAuthenticated) {
      const schoolIds = toNumericIdList(session.schoolIds)
      setTelemetryContext({
        tenantId: session.tenantId,
        schoolId: schoolIds[0],
        schoolIds,
        userId: session.userId,
        role: session.roleName,
      })
    } else {
      clearTelemetryContext()
    }
  }, [session?.tenantId, session?.userId, session?.isAuthenticated, session?.schoolIds, session?.roleName])

  return <AuthContext.Provider value={{ session, status, token }}>{props.children}</AuthContext.Provider>
}
